<template>
  <div class="sideBar">
    <div class="sideBar-item">
      <div class="sideBar-item-icon mobile" />
      <div class="sideBar-item-text">手机改卷</div>
      <div class="sideBar-item-qrcode">
        <img src="@/assets/images/h5_qrcode.png" alt="手机改卷二维码" />
      </div>
    </div>
    <div
      class="sideBar-item"
      title="点击下载扫描客户端"
      @click="
        openWindow(
          'https://21-yuejuan-api.tos-cn-beijing.volces.com/scan/二一阅卷扫描_安装包.exe'
        )
      "
    >
      <div class="sideBar-item-icon printer" />
      <div class="sideBar-item-text">扫描<br />客户端</div>
    </div>
    <div class="sideBar-item" @click="openWindow('https://yj.21cnjy.com/help/list2')">
      <div class="sideBar-item-icon help" />
      <div class="sideBar-item-text">帮助中心</div>
    </div>
    <div class="sideBar-item">
      <div class="sideBar-item-icon customerService" />
      <div class="sideBar-item-text">联系客服</div>
      <div class="sideBar-item-qrcode">
        <div>电话：13684937620</div>
        <div>微信扫码咨询客服</div>
        <img v-if="UserStore.userInfo.qrCode" :src="UserStore.userInfo.qrCode" alt="客服二维码" />
        <img v-else src="@/assets/images/wechat_qrcode.png" alt="客服二维码" />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useUserStore } from "@/store";

const UserStore = useUserStore();
const openWindow = (link: string) => {
  window.open(link, "_blank");
};
</script>
<style scoped lang="scss">
.sideBar {
  position: fixed;
  display: flex;
  flex-direction: column;
  padding: 15px 10px;
  right: 20px;
  top: 32%;
  width: 70px;
  background: #fff;
  border-radius: 4px;
}
.sideBar-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e5e5e5;
  text-align: center;
  &:last-of-type {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
  }
  &:hover {
    cursor: pointer;
    .sideBar-item-text {
      color: #2878ff;
    }
    .sideBar-item-icon {
      &.mobile {
        background-image: url("@/assets/icon/mobile_active.png");
      }
      &.printer {
        background-image: url("@/assets/icon/printer_active.png");
      }
      &.help {
        background-image: url("@/assets/icon/help_active.png");
      }
      &.customerService {
        background-image: url("@/assets/icon/customerservice_active.png");
      }
    }
    .sideBar-item-qrcode {
      display: block;
    }
  }
  .sideBar-item-icon {
    &.mobile {
      width: 24px;
      height: 24px;
      background-image: url("@/assets/icon/mobile.png");
      background-size: 100% 100%;
    }
    &.printer {
      width: 24px;
      height: 24px;
      background-image: url("@/assets/icon/printer.png");
      background-size: 100% 100%;
    }
    &.help {
      width: 24px;
      height: 24px;
      background-image: url("@/assets/icon/help.png");
      background-size: 100% 100%;
    }
    &.customerService {
      width: 24px;
      height: 24px;
      background-image: url("@/assets/icon/customerService.png");
      background-size: 100% 100%;
    }
  }
  .sideBar-item-text {
    margin-top: 10px;
    font-size: 12px;
    line-height: 16px;
  }
  .sideBar-item-qrcode {
    position: absolute;
    display: none;
    top: -15px;
    left: -180px;
    padding: 10px;
    background: #ffffff;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.12);
    border-radius: 4px 4px 4px 4px;
    img {
      width: 140px;
      height: 140px;
    }
  }
}
</style>
